'use strict';

$ = jQuery;

$(document).on('click', '#trending-posts-list a', function () {

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Post',
    'eventAction': 'Clique - Tendências',
    'eventLabel': $(this).parent().text()
  });

  gtag('event', 'Post', {
    'eventAction': 'Clique - Tendências',
    'eventLabel': $(this).parent().text()
  });
});